import { FotoWebSettings } from "./FotoWebSettings";
import { PapirflySettings } from "./PapirflySettings";

export class ImageSourceSettings {
  organizerId: number;
  fotoWeb?: FotoWebSettings;
  papirfly?: PapirflySettings;

  constructor(
    organizerId?: number,
    fotoWeb?: FotoWebSettings,
    papirfly?: PapirflySettings,
  ) {
    this.organizerId = organizerId;
    this.fotoWeb = fotoWeb;
    this.papirfly = papirfly;
  }
}
